import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";

import { axiosClient } from "../../helpers/apiClient";
import {
  addToCart as addToCartUrl,
  getCartList as getCartListUrl,
  updateCartProductQuantity as updateCartProductQuantityUrl,
  registerMemberList as registerMemberListUrl,
  addSales as addSalesUrl,
  addRegisterSales as addRegisterSalesUrl,
  getOrderList as getOrderListUrl,
  getSalesDetail as getSalesDetailUrl,
} from "../../helpers/apiUrl";
import {
  getOrderListResponse,
  memberRankingResponse,
  orderDetailsResponse,
  payloadAddToCart,
  payloadGetCartList,
  payloadMbizOrder,
  payloadOrderList,
  payloadRepeatOrder,
  payloadUpdateQuantityCart,
} from "../../types/sales";
import { Response } from "../../types/global";

export const addToCart = createAsyncThunk(
  "sales/add-shopping-cart",
  async (payload: payloadAddToCart) => {
    return axiosClient
      .post(addToCartUrl, payload)
      .then((d: AxiosResponse) => d.data)
      .then((d: AxiosResponse) => d.data);
  },
);

export const getCartList = createAsyncThunk(
  "sales/get-shopping-cart-by-memberid",
  async (payload: payloadGetCartList) => {
    return axiosClient
      .post(getCartListUrl, payload)
      .then((d: AxiosResponse) => d.data)
      .then((d: AxiosResponse) => d.data);
  },
);

export const updateCartProductQuantity = createAsyncThunk(
  "sales/update-shopping-cart-quantity",
  async (payload: payloadUpdateQuantityCart) => {
    return axiosClient
      .post(updateCartProductQuantityUrl, payload)
      .then((d: AxiosResponse) => d.data)
      .then((d: AxiosResponse) => d.data);
  },
);

export const addRepeatSales = createAsyncThunk(
  "sales/add-sales",
  async (payload: payloadRepeatOrder) => {
    return axiosClient
      .post(addSalesUrl, payload)
      .then((d: AxiosResponse) => d)
      .then((d: AxiosResponse) => d);
  },
);

export const getMemberRakingList = createAsyncThunk(
  "member/get-no-ranking-member-by-memberid",
  async (id: number) => {
    const urlWithId = `${registerMemberListUrl}/?memberid=${id}`;
    return axiosClient
      .get(urlWithId)
      .then((d: AxiosResponse<Response<memberRankingResponse[]>>) => d.data)
      .then((d: Response<memberRankingResponse[]>) => d.data);
  },
);
export const addRegisterSales = createAsyncThunk(
  "sales/add-registration-sales",
  async (payload: payloadMbizOrder) => {
    return axiosClient
      .post(addRegisterSalesUrl, payload)
      .then((d: AxiosResponse) => d)
      .then((d: AxiosResponse) => d);
  },
);

export const getOrderList = createAsyncThunk(
  "sales/report-sales",
  async (payload: payloadOrderList) => {
    return axiosClient
      .post(getOrderListUrl, payload)
      .then((d: AxiosResponse<Response<getOrderListResponse[]>>) => d.data)
      .then((d: Response<getOrderListResponse[]>) => d.data);
  },
);

export const getOrderDetails = createAsyncThunk(
  "member/get-sales-by-invoiceno",
  async (id: string) => {
    const urlWithId = `${getSalesDetailUrl}/?invoiceNo=${id}`;
    return axiosClient
      .get(urlWithId)
      .then((d: AxiosResponse<Response<orderDetailsResponse>>) => d.data)
      .then((d: Response<orderDetailsResponse>) => d.data);
  },
);
